<template>
  <div>
    <!--  -->
    <div v-if="formData.type === 'affiliate'" class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3">
        <!-- Header -->
        <div class="bg-white rounded-lg shadow mb-4">
            <div class="flex items-center justify-between p-5">
                <div class="flex items-center">
                    <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3" @click="goBackOffers()">
                        <i class="material-icons">chevron_left</i>
                    </button>
                    <div>
                        <div class="text-xs text-gray-400 uppercase tracking-wider">Offre Affiliate</div>
                        <div class="text-lg font-bold text-gray-800">{{ formData.name }}</div>
                    </div>
                </div>
                <div class="flex items-center gap-2">
                    <span v-for="(detialPr, r) in $f.removeCountryByTwoArray(formData.details,currentUser.countries)" :key="'flag-'+r">
                        <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-5 h-5 rounded-full">
                    </span>
                </div>
            </div>
        </div>

        <!-- Product Hero -->
        <div class="bg-white rounded-lg shadow mb-4 p-5">
            <div class="flex flex-wrap gap-6">
                <img class="cpa-view-img rounded-lg object-cover" :src="formData.picture" :alt="formData.name">
                <div class="flex-1" style="min-width: 240px;">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="text-xs text-gray-400 uppercase">{{ formData.category }}</span>
                    </div>
                    <h1 class="text-xl font-bold text-gray-900 mb-3 uppercase">{{ formData.name }}</h1>

                    <div class="flex flex-wrap gap-3 mb-4">
                        <a v-if="formData.details && formData.details.length > 0 && formData.details[0].affiliate && formData.details[0].affiliate.landingPage" :href="formData.details[0].affiliate.landingPage" target="_blank" class="aff-landing-btn">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg>
                            Landing page
                        </a>
                        <router-link v-if="!['Seller','Partner'].includes(currentUser.type)" :to="{ path: '/products/edit/' + formData._id }" target="_blank" class="aff-product-btn">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22 8v13h-20v-18h11v-1h-12v20h22v-14h-1zm-2-3.293l-9.707 9.707-4.293-4.293-1.414 1.414 5.707 5.707 11.121-11.121-1.414-1.414z"/></svg>
                            Page produit
                        </router-link>
                    </div>

                    <!-- Request / Status -->
                    <div v-if="['Seller','Partner'].includes(currentUser.type)" class="mt-4">
                        <div v-if="checkingRequestOffre && checkingRequestOffre.status">
                            <div v-if="checkingRequestOffre.status === 'approved'" class="cpa-status-badge cpa-status-approved">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m11.998 2.005c5.517 0 9.997 4.48 9.997 9.997 0 5.518-4.48 9.998-9.997 9.998-5.518 0-9.998-4.48-9.998-9.998 0-5.517 4.48-9.997 9.998-9.997zm-5.049 10.386 3.851 3.43c.142.128.321.19.499.19.202 0 .405-.081.552-.242l5.953-6.509c.131-.143.196-.323.196-.502 0-.41-.331-.747-.748-.747-.204 0-.405.082-.554.243l-5.453 5.962-3.298-2.938c-.144-.127-.321-.19-.499-.19-.415 0-.748.335-.748.746 0 .205.084.409.249.557z" fill-rule="nonzero"/></svg>
                                Vous êtes autorisé à exécuter cette offre
                            </div>
                            <div v-else-if="checkingRequestOffre.status === 'rejected'" class="cpa-status-badge cpa-status-rejected">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0 1.5c-4.69 0-8.5 3.81-8.5 8.5s3.81 8.5 8.5 8.5 8.5-3.81 8.5-8.5-3.81-8.5-8.5-8.5zm-4.5 7.75h9c.414 0 .75.336.75.75s-.336.75-.75.75h-9c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z"/></svg>
                                Offre rejetée
                            </div>
                            <div v-else-if="checkingRequestOffre.status === 'pending'" class="cpa-status-badge cpa-status-pending">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0 1.5c-4.69 0-8.5 3.81-8.5 8.5s3.81 8.5 8.5 8.5 8.5-3.81 8.5-8.5-3.81-8.5-8.5-8.5zm.75 3.75v5.25h4c.414 0 .75.336.75.75s-.336.75-.75.75h-4.75c-.414 0-.75-.336-.75-.75v-6c0-.414.336-.75.75-.75s.75.336.75.75z"/></svg>
                                Demande en cours de validation
                            </div>
                        </div>
                        <button v-else :disabled="loadingOffre" @click="RequestOffre" class="cpa-request-btn loidingconfirm relative">
                            <loading :active.sync="loadingOffre" :is-full-page="fullPage"></loading>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 7.001c0 3.865-3.134 7-7 7s-7-3.135-7-7c0-3.867 3.134-7.001 7-7.001s7 3.134 7 7.001zm-1.598 7.18c-1.506 1.137-3.374 1.82-5.402 1.82-2.03 0-3.899-.685-5.407-1.822-4.072 1.793-6.593 7.376-6.593 9.821h24c0-2.423-2.6-8.006-6.598-9.819z"/></svg>
                            Demander cette offre
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Commissions per warehouse (tabs) -->
        <div class="bg-white rounded-lg shadow mb-4">
            <div class="cpa-wh-tabs-header">
                <h2 class="text-base font-bold text-gray-800">Commissions</h2>
                <div class="cpa-wh-tabs" v-if="$f.removeCountryByTwoArray(formData.details,currentUser.countries).length > 1">
                    <button v-for="(detialPr, r) in $f.removeCountryByTwoArray(formData.details,currentUser.countries)" :key="'atab-'+r"
                        @click="activeWhTab = r"
                        :class="activeWhTab === r ? 'cpa-wh-tab-active' : 'cpa-wh-tab-inactive'"
                        class="cpa-wh-tab">
                        <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full">
                        <span>{{ detialPr.warehouse ? detialPr.warehouse.name : detialPr.country.toUpperCase() }}</span>
                    </button>
                </div>
            </div>
            <div v-for="(detialPr, r) in $f.removeCountryByTwoArray(formData.details,currentUser.countries)" :key="'awhc-'+r" v-show="activeWhTab === r" class="p-5">
                <div class="cpa-wh-detail">
                    <div class="cpa-wh-detail-top">
                        <div class="cpa-wh-stock-big" :class="detialPr.quantity && detialPr.quantity.inStock > 0 ? 'cpa-stock-ok' : 'cpa-stock-empty'">
                            {{ detialPr.quantity ? detialPr.quantity.inStock : 0 }} en stock
                        </div>
                        <div class="flex items-center gap-2" v-if="$f.removeCountryByTwoArray(formData.details,currentUser.countries).length === 1">
                            <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full">
                            <span class="text-sm font-semibold text-gray-600">{{ detialPr.warehouse ? detialPr.warehouse.name : detialPr.country.toUpperCase() }}</span>
                        </div>
                    </div>
                    <div class="aff-metrics-grid">
                        <div class="cpa-wh-metric">
                            <span class="cpa-wh-metric-label">Prix</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.price }} <small>{{ detialPr.warehouse ? detialPr.warehouse.currency : '' }}</small></span>
                        </div>
                        <div class="cpa-wh-metric cpa-metric-green">
                            <span class="cpa-wh-metric-label">Commission</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.commission }} <small>{{ detialPr.warehouse ? detialPr.warehouse.currency : '' }}</small></span>
                        </div>
                        <div class="cpa-wh-metric">
                            <span class="cpa-wh-metric-label">Taux confirmation</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.affiliate ? detialPr.affiliate.confirmationRate : 0 }}<small>%</small></span>
                        </div>
                        <div class="cpa-wh-metric">
                            <span class="cpa-wh-metric-label">Taux livraison</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.affiliate ? detialPr.affiliate.deliveryRate : 0 }}<small>%</small></span>
                        </div>
                    </div>
                    <!-- Upsells -->
                    <div v-if="detialPr.upsells && detialPr.upsells.length > 0" class="mt-4">
                        <div class="text-xs text-gray-400 uppercase tracking-wider mb-2">Upsells</div>
                        <div class="aff-upsell-list">
                            <div v-for="(upsel, l) in detialPr.upsells" :key="'up-'+l" class="aff-upsell-item">
                                <span class="text-sm text-gray-600">{{ upsel.quantity }} pcs</span>
                                <span class="text-sm font-semibold">{{ upsel.price }} <small class="text-gray-400">{{ detialPr.warehouse ? detialPr.warehouse.currency : '' }}</small></span>
                                <span class="text-sm font-bold" style="color: #059669;">{{ upsel.commission }} <small class="text-gray-400">{{ detialPr.warehouse ? detialPr.warehouse.currency : '' }}</small></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Description -->
        <div v-if="formData.description" class="bg-white rounded-lg shadow mb-4">
            <div class="p-5 border-b border-gray-100">
                <h2 class="text-base font-bold text-gray-800">Description</h2>
            </div>
            <div class="p-5">
                <div class="cpa-description" v-html="formData.description"></div>
            </div>
        </div>

        <!-- Tracking Links (approved only) -->
        <template v-if="['Seller','Partner'].includes(currentUser.type) && checkingRequestOffre && checkingRequestOffre.status === 'approved'">
            <div class="bg-white rounded-lg shadow mb-4">
                <div class="p-5 border-b border-gray-100">
                    <div class="flex items-center gap-2">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#059669"><path d="M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z"/></svg>
                        <h2 class="text-base font-bold text-gray-800">Lien de suivi</h2>
                    </div>
                    <p class="text-xs text-gray-400 mt-1">Utilisez ce lien directement pour promouvoir l'offre — pas besoin de store ou landing page</p>
                </div>
                <div class="p-5">
                    <div v-for="(detialPr, r) in $f.removeCountryByTwoArray(formData.details,currentUser.countries)" :key="'link-'+r" class="aff-tracking-row">
                        <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full flex-shrink-0">
                        <span class="aff-tracking-url">{{ generaterefLink(detialPr.affiliate.landingPage,detialPr.country) }}</span>
                        <button @click="Copy(generaterefLink(detialPr.affiliate.landingPage,detialPr.country))" class="aff-copy-btn">
                            <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor"><path d="M7.5 1.67H15.83c.92 0 1.67.75 1.67 1.66v10c0 .46-.38.84-.83.84-.46 0-.84-.38-.84-.84V4.17c0-.46-.37-.84-.83-.84H7.5c-.46 0-.83-.37-.83-.83 0-.46.37-.83.83-.83zM4.17 5H12.5c.92 0 1.67.75 1.67 1.67V16.67c0 .92-.75 1.66-1.67 1.66H4.17c-.92 0-1.67-.74-1.67-1.66V6.67C2.5 5.75 3.25 5 4.17 5zM5 16.67h6.67c.46 0 .83-.38.83-.84V7.5c0-.46-.37-.83-.83-.83H5c-.46 0-.83.37-.83.83v8.33c0 .46.37.84.83.84z"/></svg>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Integration (own store / landing page) -->
            <div class="bg-white rounded-lg shadow mb-4">
                <div class="p-5 border-b border-gray-100">
                    <div class="flex items-center gap-2">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#2563eb"><path d="M24 10.935v2.131l-8 3.947v-2.23l5.64-2.783-5.64-2.79v-2.223l8 3.948zm-16 3.848l-5.64-2.783 5.64-2.79v-2.223l-8 3.948v2.131l8 3.947v-2.23zm7.047-10.783h-2.078l-4.011 16h2.073l4.016-16z"/></svg>
                        <h2 class="text-base font-bold text-gray-800">Intégration</h2>
                    </div>
                    <p class="text-xs text-gray-400 mt-1">Si vous travaillez avec votre propre store ou landing page</p>
                </div>
                <div class="p-5">
                    <div class="aff-integration-item" style="max-width: 400px;">
                        <span class="aff-integration-label">ID Produit</span>
                        <div class="aff-integration-val-row">
                            <code class="aff-integration-code">{{ checkingRequestOffre.productObject.id }}</code>
                            <button @click="Copy(checkingRequestOffre.productObject.id)" class="aff-copy-btn-sm">
                                <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor"><path d="M7.5 1.67H15.83c.92 0 1.67.75 1.67 1.66v10c0 .46-.38.84-.83.84-.46 0-.84-.38-.84-.84V4.17c0-.46-.37-.84-.83-.84H7.5c-.46 0-.83-.37-.83-.83 0-.46.37-.83.83-.83zM4.17 5H12.5c.92 0 1.67.75 1.67 1.67V16.67c0 .92-.75 1.66-1.67 1.66H4.17c-.92 0-1.67-.74-1.67-1.66V6.67C2.5 5.75 3.25 5 4.17 5zM5 16.67h6.67c.46 0 .83-.38.83-.84V7.5c0-.46-.37-.83-.83-.83H5c-.46 0-.83.37-.83.83v8.33c0 .46.37.84.83.84z"/></svg>
                            </button>
                        </div>
                    </div>
                    <div class="aff-note mt-4">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="#2563eb"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                        <div class="text-xs text-gray-600">
                            Suivez les étapes d'<b>intégration Google Sheet</b> avec votre plateforme (Storeino, Shopify, YouCan, Wordpress...). Vous pouvez appliquer un prix différent — votre commission sera: <b>(Votre prix - Prix de base) + Commission de base</b>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Creative content -->
            <div class="bg-white rounded-lg shadow mb-4">
                <div class="p-5 border-b border-gray-100">
                    <h2 class="text-base font-bold text-gray-800">Contenus publicitaires</h2>
                </div>
                <div class="p-5">
                    <div v-for="(detialPr, r) in $f.removeCountryByTwoArray(formData.details,currentUser.countries)" :key="'cr-'+r" class="aff-creative-row">
                        <div class="flex items-center gap-2">
                            <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full">
                            <span class="text-sm font-medium text-gray-700">Creative Videos</span>
                        </div>
                        <a v-if="detialPr.affiliate && detialPr.affiliate.linkDrive" :href="detialPr.affiliate.linkDrive" target="_blank" class="aff-drive-link">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z"/></svg>
                            Ouvrir
                        </a>
                        <span v-else class="text-xs text-gray-400">—</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <!--  CPA View -->
    <div v-if="formData.type === 'cpa'" class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3">
        <!-- Header -->
        <div class="bg-white rounded-lg shadow mb-4">
            <div class="flex items-center justify-between p-5">
                <div class="flex items-center">
                    <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3" @click="goBackOffers">
                        <i class="material-icons">chevron_left</i>
                    </button>
                    <div>
                        <div class="text-xs text-gray-400 uppercase tracking-wider">Offre CPA</div>
                        <div class="text-lg font-bold text-gray-800">{{ formData.name }}</div>
                    </div>
                </div>
                <div class="flex items-center gap-2">
                    <span v-for="(detialPr, r) in cpaDetails" :key="'flag-'+r">
                        <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-5 h-5 rounded-full">
                    </span>
                </div>
            </div>
        </div>

        <!-- Product Hero -->
        <div class="bg-white rounded-lg shadow mb-4 p-5">
            <div class="flex flex-wrap gap-6">
                <img class="cpa-view-img rounded-lg object-cover" :src="formData.picture" :alt="formData.name">
                <div class="flex-1" style="min-width: 240px;">
                    <div class="flex items-center gap-2 mb-1">
                        <span class="text-xs text-gray-400 uppercase">{{ formData.category }}</span>
                    </div>
                    <h1 class="text-xl font-bold text-gray-900 mb-3 uppercase">{{ formData.name }}</h1>

                    <div v-if="formData.cpa && !['Seller','Partner'].includes(currentUser.type)" class="cpa-info-grid">
                        <div class="cpa-info-item">
                            <span class="cpa-info-label">Fournisseur</span>
                            <span class="cpa-info-value">{{ formData.cpa.supplierName || '—' }}</span>
                        </div>
                    </div>

                    <!-- Request / Status (Seller CPA) -->
                    <div v-if="['Seller','Partner'].includes(currentUser.type)" class="mt-4">
                        <div v-if="checkingRequestOffre && checkingRequestOffre.status">
                            <div v-if="checkingRequestOffre.status === 'approved'" class="cpa-status-badge cpa-status-approved">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m11.998 2.005c5.517 0 9.997 4.48 9.997 9.997 0 5.518-4.48 9.998-9.997 9.998-5.518 0-9.998-4.48-9.998-9.998 0-5.517 4.48-9.997 9.998-9.997zm-5.049 10.386 3.851 3.43c.142.128.321.19.499.19.202 0 .405-.081.552-.242l5.953-6.509c.131-.143.196-.323.196-.502 0-.41-.331-.747-.748-.747-.204 0-.405.082-.554.243l-5.453 5.962-3.298-2.938c-.144-.127-.321-.19-.499-.19-.415 0-.748.335-.748.746 0 .205.084.409.249.557z" fill-rule="nonzero"/></svg>
                                Demande approuvée
                            </div>
                            <div v-else-if="checkingRequestOffre.status === 'rejected'" class="cpa-status-badge cpa-status-rejected">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0 1.5c-4.69 0-8.5 3.81-8.5 8.5s3.81 8.5 8.5 8.5 8.5-3.81 8.5-8.5-3.81-8.5-8.5-8.5zm-4.5 7.75h9c.414 0 .75.336.75.75s-.336.75-.75.75h-9c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z"/></svg>
                                Demande rejetée
                            </div>
                            <div v-else-if="checkingRequestOffre.status === 'pending'" class="cpa-status-badge cpa-status-pending">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0 1.5c-4.69 0-8.5 3.81-8.5 8.5s3.81 8.5 8.5 8.5 8.5-3.81 8.5-8.5-3.81-8.5-8.5-8.5zm.75 3.75v5.25h4c.414 0 .75.336.75.75s-.336.75-.75.75h-4.75c-.414 0-.75-.336-.75-.75v-6c0-.414.336-.75.75-.75s.75.336.75.75z"/></svg>
                                Demande en cours de validation
                            </div>
                        </div>
                        <button v-else :disabled="loadingOffre" @click="RequestOffre" class="cpa-request-btn loidingconfirm relative">
                            <loading :active.sync="loadingOffre" :is-full-page="fullPage"></loading>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19 7.001c0 3.865-3.134 7-7 7s-7-3.135-7-7c0-3.867 3.134-7.001 7-7.001s7 3.134 7 7.001zm-1.598 7.18c-1.506 1.137-3.374 1.82-5.402 1.82-2.03 0-3.899-.685-5.407-1.822-4.072 1.793-6.593 7.376-6.593 9.821h24c0-2.423-2.6-8.006-6.598-9.819z"/></svg>
                            Demander cette offre
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Commissions per warehouse (tabs) -->
        <div v-if="cpaDetails.length > 0" class="bg-white rounded-lg shadow mb-4">
            <div class="cpa-wh-tabs-header">
                <h2 class="text-base font-bold text-gray-800">Commissions & Disponibilité</h2>
                <div class="cpa-wh-tabs" v-if="cpaDetails.length > 1">
                    <button v-for="(detialPr, r) in cpaDetails" :key="'tab-'+r"
                        @click="activeWhTab = r"
                        :class="activeWhTab === r ? 'cpa-wh-tab-active' : 'cpa-wh-tab-inactive'"
                        class="cpa-wh-tab">
                        <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full">
                        <span>{{ detialPr.warehouse ? detialPr.warehouse.name : detialPr.country.toUpperCase() }}</span>
                    </button>
                </div>
            </div>
            <div class="p-5" v-for="(detialPr, r) in cpaDetails" :key="'whc-'+r" v-show="activeWhTab === r">
                <div class="cpa-wh-detail">
                    <div class="cpa-wh-detail-top">
                        <div class="cpa-wh-stock-big" :class="detialPr.quantity && detialPr.quantity.inStock > 0 ? 'cpa-stock-ok' : 'cpa-stock-empty'">
                            {{ detialPr.quantity ? detialPr.quantity.inStock : 0 }} en stock
                        </div>
                        <div class="flex items-center gap-2">
                            <span v-if="cpaDetails.length === 1" class="flex items-center gap-2">
                                <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full">
                                <span class="text-sm font-semibold text-gray-600">{{ detialPr.warehouse ? detialPr.warehouse.name : detialPr.country.toUpperCase() }}</span>
                            </span>
                            <span :class="(detialPr.cpa ? detialPr.cpa.activeCommissionMode : (formData.cpa ? formData.cpa.activeCommissionMode : 'confirmed')) === 'confirmed' ? 'cpa-mode-pill-blue' : 'cpa-mode-pill-green'" class="cpa-mode-pill">
                                Mode: {{ (detialPr.cpa ? detialPr.cpa.activeCommissionMode : (formData.cpa ? formData.cpa.activeCommissionMode : 'confirmed')) === 'confirmed' ? 'Confirmé' : 'Livraison' }}
                            </span>
                        </div>
                    </div>
                    <div class="cpa-wh-metrics">
                        <div class="cpa-wh-metric">
                            <span class="cpa-wh-metric-label">Prix de vente</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.cpa ? detialPr.cpa.salePrice : (formData.cpa ? formData.cpa.salePrice : 0) }} <small>{{ detialPr.currency || (detialPr.warehouse ? detialPr.warehouse.currency : '') }}</small></span>
                        </div>
                        <div class="cpa-wh-metric cpa-metric-blue">
                            <span class="cpa-wh-metric-label">Commission Confirmé</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.cpa ? detialPr.cpa.confirmedCommission : (formData.cpa ? formData.cpa.confirmedCommission : 0) }} <small>{{ detialPr.currency || (detialPr.warehouse ? detialPr.warehouse.currency : '') }}</small></span>
                        </div>
                        <div class="cpa-wh-metric cpa-metric-green">
                            <span class="cpa-wh-metric-label">Commission Livraison</span>
                            <span class="cpa-wh-metric-val">{{ detialPr.cpa ? detialPr.cpa.deliveryCommission : (formData.cpa ? formData.cpa.deliveryCommission : 0) }} <small>{{ detialPr.currency || (detialPr.warehouse ? detialPr.warehouse.currency : '') }}</small></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Description -->
        <div v-if="formData.description" class="bg-white rounded-lg shadow mb-4">
            <div class="p-5 border-b border-gray-100">
                <h2 class="text-base font-bold text-gray-800">Description</h2>
            </div>
            <div class="p-5">
                <div class="cpa-description" v-html="formData.description"></div>
            </div>
        </div>

        <!-- Integration (approved CPA sellers only) -->
        <template v-if="['Seller','Partner'].includes(currentUser.type) && checkingRequestOffre && checkingRequestOffre.status === 'approved'">
            <div class="bg-white rounded-lg shadow mb-4">
                <div class="p-5 border-b border-gray-100">
                    <div class="flex items-center gap-2">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#2563eb"><path d="M24 10.935v2.131l-8 3.947v-2.23l5.64-2.783-5.64-2.79v-2.223l8 3.948zm-16 3.848l-5.64-2.783 5.64-2.79v-2.223l-8 3.948v2.131l8 3.947v-2.23zm7.047-10.783h-2.078l-4.011 16h2.073l4.016-16z"/></svg>
                        <h2 class="text-base font-bold text-gray-800">Intégration</h2>
                    </div>
                    <p class="text-xs text-gray-400 mt-1">Si vous travaillez avec votre propre store ou landing page</p>
                </div>
                <div class="p-5">
                    <div class="aff-integration-item" style="max-width: 400px;">
                        <span class="aff-integration-label">ID Produit</span>
                        <div class="aff-integration-val-row">
                            <code class="aff-integration-code">{{ checkingRequestOffre.productObject.id }}</code>
                            <button @click="Copy(checkingRequestOffre.productObject.id)" class="aff-copy-btn-sm">
                                <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor"><path d="M7.5 1.67H15.83c.92 0 1.67.75 1.67 1.66v10c0 .46-.38.84-.83.84-.46 0-.84-.38-.84-.84V4.17c0-.46-.37-.84-.83-.84H7.5c-.46 0-.83-.37-.83-.83 0-.46.37-.83.83-.83zM4.17 5H12.5c.92 0 1.67.75 1.67 1.67V16.67c0 .92-.75 1.66-1.67 1.66H4.17c-.92 0-1.67-.74-1.67-1.66V6.67C2.5 5.75 3.25 5 4.17 5zM5 16.67h6.67c.46 0 .83-.38.83-.84V7.5c0-.46-.37-.83-.83-.83H5c-.46 0-.83.37-.83.83v8.33c0 .46.37.84.83.84z"/></svg>
                            </button>
                        </div>
                    </div>
                    <div class="aff-note mt-4">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="#2563eb"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                        <div class="text-xs text-gray-600">
                            Suivez les étapes d'<b>intégration Google Sheet</b> avec votre plateforme (Storeino, Shopify, YouCan, Wordpress...). Le prix de vente est fixé par le fournisseur — votre commission est calculée automatiquement selon le mode actif (<b>Confirmé</b> ou <b>Livraison</b>).
                        </div>
                    </div>
                </div>
            </div>

            <!-- Profit Calculator -->
            <div class="bg-white rounded-lg shadow mb-4">
                <div class="p-5 border-b border-gray-100">
                    <div class="flex items-center gap-2">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#d97706"><path d="M5 2h14c.553 0 1 .448 1 1v18c0 .553-.447 1-1 1h-14c-.552 0-1-.447-1-1v-18c0-.552.448-1 1-1zm1 4v2h5v-2h-5zm7 0v2h5v-2h-5zm-7 4v2h5v-2h-5zm7 0v2h5v-2h-5zm-7 4v2h5v-2h-5zm7 0v6h5v-6h-5zm-7 4v2h5v-2h-5z"/></svg>
                        <h2 class="text-base font-bold text-gray-800">Calculateur de profit</h2>
                    </div>
                    <p class="text-xs text-gray-400 mt-1">Estimez vos gains par commande et par volume</p>
                </div>
                <div class="p-5">
                    <div v-for="(detialPr, r) in cpaDetails" :key="'calc-'+r" class="cpa-calc-block" :class="{'mt-4 pt-4': r > 0}" :style="r > 0 ? 'border-top: 1px dashed #e5e7eb' : ''">
                        <div class="flex items-center gap-2 mb-3">
                            <img :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' + detialPr.country.toLowerCase() + '.svg'" class="w-4 h-4 rounded-full">
                            <span class="text-sm font-semibold text-gray-700">{{ detialPr.warehouse ? detialPr.warehouse.name : detialPr.country.toUpperCase() }}</span>
                            <span class="cpa-calc-mode-pill" :class="(detialPr.cpa ? detialPr.cpa.activeCommissionMode : 'confirmed') === 'confirmed' ? 'cpa-calc-mode-blue' : 'cpa-calc-mode-green'">
                                {{ (detialPr.cpa ? detialPr.cpa.activeCommissionMode : 'confirmed') === 'confirmed' ? 'Confirmé' : 'Livraison' }}
                            </span>
                        </div>
                        <div class="cpa-calc-inputs">
                            <div class="cpa-calc-field">
                                <label class="cpa-calc-label">Nombre de commandes</label>
                                <div class="cpa-calc-input-wrap">
                                    <input type="number" v-model.number="cpaCalcQty[detialPr.country]" class="cpa-calc-input" placeholder="10" min="1">
                                </div>
                            </div>
                            <div class="cpa-calc-field">
                                <label class="cpa-calc-label">Quantité / commande</label>
                                <div class="cpa-calc-input-wrap">
                                    <input type="number" v-model.number="cpaCalcUnitQty[detialPr.country]" class="cpa-calc-input" placeholder="1" min="1">
                                </div>
                            </div>
                        </div>
                        <div class="cpa-calc-results">
                            <div class="cpa-calc-result-item">
                                <span class="cpa-calc-result-label">Commission / unité</span>
                                <span class="cpa-calc-result-val cpa-calc-val-blue">
                                    {{ getCpaCommission(detialPr) }} <small>{{ detialPr.currency || '' }}</small>
                                </span>
                            </div>
                            <div class="cpa-calc-result-item">
                                <span class="cpa-calc-result-label">Commission / commande</span>
                                <span class="cpa-calc-result-val cpa-calc-val-blue">
                                    {{ getCpaCommissionPerOrder(detialPr) }} <small>{{ detialPr.currency || '' }}</small>
                                </span>
                            </div>
                            <div class="cpa-calc-result-item cpa-calc-result-total">
                                <span class="cpa-calc-result-label">Profit total estimé</span>
                                <span class="cpa-calc-result-val cpa-calc-val-green">
                                    {{ getCpaTotalProfit(detialPr) }} <small>{{ detialPr.currency || '' }}</small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <!--  -->
  </div>
</template>
<script>
export default {
        props: {
            currentUser: { type: Object},
            idWharhouse: { type: Object}
        },
        data() {
            return {
                loading:false,
                loadingOffre:false,
                fullPage:false,
                formData: {
                    seller:{},
                    type:"",
                    details: [],
                },
                checkingRequestOffre:null,
                activeWhTab: 0,
                cpaCalc: {},
                cpaCalcQty: {},
                cpaCalcUnitQty: {}
            };
        },
        async mounted() {
            if (this.$route.params.id) {
                const {content:data} = await this.$server.get("products", {id: this.$route.params.id});
                console.log('data-------',data)
                if(!['affiliate','cpa'].includes(data.type)) return this.$toast.warning("Ce produit n'est ni un produit affiliate ni CPA");
                this.formData = data;
                if(['Seller','Partner'].includes(this.currentUser.type)){
                    const {content:dataOffre} = await this.$server.get("affiliates", {product: this.$route.params.id,notPopulate:true});
                    if(dataOffre && dataOffre._id) this.checkingRequestOffre=dataOffre;
                    console.log('dataOffre-------',dataOffre)
                }
                if (data.type === 'cpa' && data.details) {
                    data.details.forEach(d => {
                        this.$set(this.cpaCalc, d.country, d.cpa ? d.cpa.salePrice : 0);
                        this.$set(this.cpaCalcQty, d.country, 10);
                        this.$set(this.cpaCalcUnitQty, d.country, 1);
                    });
                }  
            }
          
        },
        computed: {
            cpaDetails() {
                const details = this.$f.removeCountryByTwoArray(this.formData.details, this.currentUser.countries);
                if (['Seller','Partner'].includes(this.currentUser.type)) {
                    return details.filter(d => d.cpaStatus === 'approved');
                }
                return details;
            },
        },
        methods: {
            RouterBack: function() {
                this.$router.back();
            },
            goBackOffers() {
                const tab = this.formData.type === 'cpa' ? 'cpa' : 'affiliate';
                this.$router.push({ path: '/affiliates/offers', query: { tab } });
            },
            Copy(text){
               console.log('text')
               const vm=this
                this.$copyText(text).then(function (e) {
                    vm.$toast.success('Copied');
                    console.log(e)
                }, function (e) {
                    vm.$toast.warning('Can not copy');
                    console.log(e)
                })
            },
            getCpaCommission(detail) {
                if (!detail.cpa) return 0;
                const mode = detail.cpa.activeCommissionMode || 'confirmed';
                return mode === 'confirmed' ? (detail.cpa.confirmedCommission || 0) : (detail.cpa.deliveryCommission || 0);
            },
            getCpaCommissionPerOrder(detail) {
                const unitQty = this.cpaCalcUnitQty[detail.country] || 1;
                return this.getCpaCommission(detail) * unitQty;
            },
            getCpaTotalProfit(detail) {
                const orders = this.cpaCalcQty[detail.country] || 10;
                const unitQty = this.cpaCalcUnitQty[detail.country] || 1;
                return this.getCpaCommission(detail) * unitQty * orders;
            },
            generaterefLink(link,country){
                if(link){
                    if (link.substring(link.length-1) == "/") link = link.substring(0, link.length-1);
                   // link+=`?rmexpress=${this.currentUser.api.ref}-${this.checkingRequestOffre.productObject.id}-${country}`;
                    link+=`?referral=${this.currentUser.api.ref}-${this.checkingRequestOffre.productObject.id}-${country}-mlafrica`;
                    return link;
                }else return "";
               
            },
            async RequestOffre() {
                this.$confirm("Êtes-vous sûr de demander cette offre ?").then(async (res) => {
                    if (res) {
                        this.loadingOffre=true;
                        const { content: dataAffiliate } = await this.$server.create("affiliates",this.formData);
                        this.loadingOffre=false;
                        console.log('dataAffiliate---------',dataAffiliate)
                        if(dataAffiliate && dataAffiliate._id){
                            this.checkingRequestOffre=dataAffiliate;
                            return this.$toast.success("Votre demande a ete envoyé avec succès");
                        }else return this.$toast.warning(dataAffiliate);
                    }
               });
            },
            async getUser() {
                const res = await this.$me;
                this.currentUser = res.content;
            },
            async getSourcingsHistories() {
                const res = await this.$server.search("sourcingsHistories", {sourcing:this.$route.params.id});
                if (res.content.results) {
                    this.sourcingsHistories = res.content.results;
                    this.sourcingsHistories.total = res.content.total;
                    this.sourcingsHistories.lastpage = res.content.last_page;
                    this.sourcingsHistories.per_page = res.content.per_page;
                    this.sourcingsHistories.currentpage = res.content.current_page;
                } else this.sourcingsHistories = [];
            },
            async paginatation(direction){
                var page=0;
                if(direction == "next"){
                    page=++this.paginate.currentpage;
                }else{
                    page=--this.paginate.currentpage;
                }
                const filters = {
                    page: page,
                    limit: this.limit,
                };
                this.getSourcingsHistories(filters);
            },
            QuantityTotalOrPrices(type,data){
                var value=0;
                for (let i in data) {
                    if(type=='qte') value+=data[i].quantity;
                    else if(type=='fees') value+=data[i].price;
                    else if(type=='feesMAD') value+=data[i].priceDH;
                    else if(type=='priceMAD')  value+=(parseFloat(data[i].priceDH)*parseFloat(data[i].quantity));
                    else value+=(parseFloat(data[i].price)*parseFloat(data[i].quantity));
                    
                }
                return value;
            },
            ShowPopUpInformation(index) {
                let modal_id = "modal_" + index;
                this.$refs[modal_id][0].showModal();
            },
            async closePopUpInformation(index) {
                let modal_id = "modal_" + index;
                this.$refs[modal_id][0].close();
            },
        },
    };
</script>

<style scoped>
 .flat-table-row{
    border-bottom-color: #323d48;
    border-bottom-width: 1px;
    border-top-color: #333f4b;
    border-top-width: 1px;
}
.referral{
    background-color: #01a6532e;
}
.text-tiny {
  font-size: 13px;
  line-height: 16px;
}
.text-container{
  height: 44px;
}
.text-container span{
  font-size: 15px;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.referral-link__copy .flat-button-width-icon-single {
  height: 1.75rem !important;
  width: 1.75rem !important;
  padding: .25rem !important;
  min-width: fit-content;
  border-radius: .25rem;
  line-height: 1rem;
  text-decoration: none;
}
.mdc-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: none;
  outline: none;
  user-select: none;
  -webkit-appearance: none;
  overflow: visible;
  vertical-align: middle;
  background: rgba(0,0,0,0);
  cursor: pointer;
}
.description{
    padding: 10px;
    background-color: #01a6532e;
}
.upsel-el{
    border-left: 3px solid black;
    padding-left: 5px;
    margin-left: 10px;
}
.upsell-td{
    border-top: 2px dashed black;
}
.upsells td{
    padding: 0.5rem 0.938rem !important;
}
.ciblage{
    font-size: 15px;
}
.bx--inline-notification__icon{
    fill: #01a653;
}
.bx--inline-notification {
    border-left: 3px solid #01a653;
}
.flat-table {
  position: relative;
  width: 100%;
  font-family: Inter,sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-indent: 0;
  border-color: inherit;
  border-collapse: collapse;
}
.flat-table .flat-table-header-row {
  height: 2.5rem;
  background-color: #01a6532e;
}
.dark .flat-table .flat-table-header-cell {
  background-color:#2c313c;
}
.flat-table tr th:first-child {
  padding-left: 0.5rem;
}
.flat-table .flat-table-header-cell {
  white-space: nowrap;
  text-align: left;
  font-weight: 400;
  color: #6b7780;
}
.flat-table tr th {
  padding: 0 0.938rem;
}
.flat-table tr td:first-child {
  padding-left:  0.5rem;
}
.flat-table tr td {
  padding: 1rem 0.938rem;
  vertical-align: middle;
}
.whitespace-pre {
  white-space: pre;
}
.ml-8 {
  margin-left: .5rem;
}
.mb-16 {
  margin-bottom: 1rem;
}
.h-36 {
  height: 2.25rem;
}
.text-sub {
  font-size: 18px;
  line-height: 21.78px;
}
.rounded-mdx {
  border-radius: 8px;
}
.w-140 {
  width: 12.75rem;
}
.h-140 {
  height: 12.75rem;
}
.text-xl {
  font-size: 24px;
  line-height: 32px;
}
.mt-8 {
  margin-top: .5rem;
}
.mb-24 {
  margin-bottom: 1rem;
}
.mod-base-button{
    transition: background-color .4s ease-out;
    padding-right: .5rem;
  padding-left: .75rem;
  z-index: 2;
  background-color: #292e3a;
  color: #fdf9f9;
  position: relative;
  display: inline-flex;
  overflow: hidden;
  width: fit-content;
  min-width: 2.25rem;
  height: 2.25rem;
  align-items: center;
  border-radius: .375rem;
  -webkit-box-shadow: 0 0 0 .2rem transparent;
  -moz-box-shadow: 0 0 0 .2rem transparent;
  font-size: .875rem;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}
.mod-base-button-inner {
  display: inline-flex;
  align-items: center;
  column-gap: .5rem;
  visibility: visible;
  font-size: 14px;
  line-height: 20px;
}

/* CPA View Styles */
.cpa-view-img {
  width: 200px;
  height: 200px;
  flex-shrink: 0;
}
.cpa-info-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cpa-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cpa-info-label {
  font-size: 13px;
  color: #9ca3af;
  min-width: 100px;
}
.cpa-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}
.cpa-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}
.cpa-status-approved {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}
.cpa-status-rejected {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}
.cpa-status-pending {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #fde68a;
}
.cpa-request-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #059669;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.cpa-request-btn:hover {
  background: #047857;
}
.cpa-request-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cpa-wh-tabs-header {
  padding: 16px 20px 0;
  border-bottom: 1px solid #e5e7eb;
}
.cpa-wh-tabs-header h2 {
  margin-bottom: 12px;
}
.cpa-wh-tabs {
  display: flex;
  gap: 4px;
  overflow-x: auto;
}
.cpa-wh-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  color: #6b7280;
  border-radius: 6px 6px 0 0;
}
.cpa-wh-tab:hover {
  background: #f3f4f6;
}
.cpa-wh-tab-active {
  color: #059669;
  font-weight: 600;
  border-bottom-color: #059669;
  background: #f0fdf4;
}
.cpa-wh-tab-inactive {
  color: #6b7280;
}
.cpa-wh-tab-rejected {
  opacity: 0.5;
}
.cpa-tab-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.cpa-tab-dot-green {
  background: #059669;
}
.cpa-tab-dot-red {
  background: #dc2626;
}
.cpa-tab-dot-orange {
  background: #d97706;
}
.cpa-wh-detail-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.cpa-wh-stock-big {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
}
.cpa-stock-ok {
  background: #ecfdf5;
  color: #059669;
}
.cpa-stock-empty {
  background: #fef2f2;
  color: #dc2626;
}
.cpa-wh-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.cpa-wh-metric {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cpa-wh-metric-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.cpa-wh-metric-val {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.2;
}
.cpa-wh-metric-val small {
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
}
.cpa-metric-blue {
  border-color: #bfdbfe;
  background: #eff6ff;
}
.cpa-metric-blue .cpa-wh-metric-val {
  color: #2563eb;
}
.cpa-metric-green {
  border-color: #a7f3d0;
  background: #ecfdf5;
}
.cpa-metric-green .cpa-wh-metric-val {
  color: #059669;
}
@media (max-width: 768px) {
  .cpa-wh-metrics {
    grid-template-columns: 1fr;
  }
}
.cpa-mode-pill {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
}
.cpa-mode-pill-blue {
  background: #eff6ff;
  color: #2563eb;
}
.cpa-mode-pill-green {
  background: #ecfdf5;
  color: #059669;
}
.cpa-description {
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
}
.cpa-description img {
  max-width: 100%;
  border-radius: 8px;
}
@media (max-width: 640px) {
  .cpa-view-img {
    width: 100%;
    height: 200px;
  }
  .cpa-warehouse-grid {
    grid-template-columns: 1fr;
  }
}

/* Affiliate View Styles */
.aff-landing-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  background: #292e3a;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;
}
.aff-landing-btn:hover {
  background: #1f2329;
  color: #fff;
  text-decoration: none;
}
.aff-metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
@media (max-width: 768px) {
  .aff-metrics-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .aff-metrics-grid {
    grid-template-columns: 1fr;
  }
}
.aff-upsell-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.aff-upsell-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  border-left: 3px solid #059669;
}
.aff-tracking-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
}
.aff-tracking-url {
  flex: 1;
  font-size: 13px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aff-copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}
.aff-copy-btn:hover {
  background: #f3f4f6;
  color: #374151;
}
.aff-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 12px 14px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 8px;
}
.aff-note svg {
  flex-shrink: 0;
  margin-top: 1px;
}
.aff-creative-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
}
.aff-drive-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #059669;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.2s;
}
.aff-drive-link:hover {
  background: #047857;
  color: #fff;
  text-decoration: none;
}
.aff-product-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}
.aff-product-btn:hover {
  background: #f3f4f6;
  color: #111827;
  text-decoration: none;
}
.aff-integration-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
@media (max-width: 640px) {
  .aff-integration-grid {
    grid-template-columns: 1fr;
  }
}
.aff-integration-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.aff-integration-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.aff-integration-val-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.aff-integration-code {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  background: #e5e7eb;
  padding: 4px 10px;
  border-radius: 4px;
  font-family: monospace;
  word-break: break-all;
}
.aff-copy-btn-sm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
}
.aff-copy-btn-sm:hover {
  background: #f3f4f6;
  color: #374151;
}

/* CPA Profit Calculator */
.cpa-calc-inputs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.cpa-calc-field {
  flex: 1;
  min-width: 160px;
}
.cpa-calc-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.cpa-calc-input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s;
}
.cpa-calc-input-wrap:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.cpa-calc-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 10px 12px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  background: #fff;
  min-width: 0;
}
.cpa-calc-input::placeholder {
  color: #9ca3af;
  font-weight: 400;
}
.cpa-calc-currency {
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  background: #f9fafb;
  align-self: stretch;
  display: flex;
  align-items: center;
  border-left: 1px solid #e5e7eb;
}
.cpa-calc-results {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.cpa-calc-result-item {
  flex: 1;
  min-width: 140px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cpa-calc-result-total {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.cpa-calc-result-label {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.cpa-calc-result-val {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.cpa-calc-result-val small {
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
}
.cpa-calc-val-blue { color: #2563eb; }
.cpa-calc-val-green { color: #059669; }
.cpa-calc-val-red { color: #dc2626; }
.cpa-calc-mode-pill {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  letter-spacing: 0.3px;
}
.cpa-calc-mode-blue { background: #eff6ff; color: #2563eb; }
.cpa-calc-mode-green { background: #ecfdf5; color: #059669; }
</style>